module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"review_detail_title":"レビュー詳細を見る"}}')
  delete Component.options._Ctor
}
